<template>
  <div class="exam-calc">
    <md-layout
      :md-gutter="24"
      md-flex="100"
    >
      <md-layout
        md-flex="100"
        class="inputs-calc"
      >
        <md-input-container>
          <label>Ferro sérico (µg/dL)</label>
          <md-input
            id="serumIron"
            v-model="exam.fields.serumIron"
            v-validate="'required'"
            v-mask="`###`"
            data-vv-validate-on="none"
            name="serumIron"
            title="Ferro sérico (µg/dL)"
            placeholder="Ferro sérico (µg/dL)"
            @keyup.enter.native="calculate()"
          />
          <input
            v-model="exam.fields.serumIron"
            v-mask="`###`"
            type="hidden"
          >
        </md-input-container>

        <md-input-container>
          <label>CLCF (µg/dL)</label>
          <md-input
            id="ironCombination"
            v-model="exam.fields.ironCombination"
            v-validate="'required'"
            v-mask="`###`"
            data-vv-validate-on="none"
            name="ironCombination"
            title="CLCF (µg/dL)"
            placeholder="CLCF (µg/dL)"
            @keyup.enter.native="calculate()"
          />
          <input
            v-model="exam.fields.ironCombination"
            v-mask="`###`"
            type="hidden"
          >
        </md-input-container>
        <button
          class="btn btn-primary btn-calc"
          @click="calculate()"
        >
          Calcular
        </button>
      </md-layout>
    </md-layout>

    <div class="calc-card__result">
      <template>
        <p>
          Resultado: <span>{{ exam.result }}µg/dL</span>
        </p>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CalcSuperfícieCorporal',
  data: () => {
    return {
      exam: {
        fields: {
          serumIron: null,
          ironCombination: null
        },
        result: 0
      }
    }
  },
  methods: {
    calculate() {
      if (this.exam.fields.serumIron && this.exam.fields.ironCombination) {
        const serumIron = +this.exam.fields.serumIron
        const ironCombination = +this.exam.fields.ironCombination

        this.exam.result = serumIron + ironCombination
      }
    }
  }
}
</script>

